module.exports = {
    onBoarding: {
        bannerImageUrl: 'https://image.ibb.co/kHaHwe/shopping_guy_3x.jpg',
        content: '<html><h2>We\'re trying something new</h2><p>By choosing how you\'d like to receive your groceries at the start of your shop, we can show you the latest range and prices.</p></html>',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/onboarding.js